<template>
  <div>
    <div class="card-item" :class="{ 'card-item--active': isSelectedToTarja }">
      <!-- Thumbnail -->
      <div class="card-item__media">
        <v-img
          v-if="item.camera.thumbnail_url"
          :src="item.camera.thumbnail_url"
          alt="Thumb câmera"
          contain
        />
        <CameraIcon
          v-else
          style="width: 64px; height: 64px; fill: var(--v-icon_default-base)"
        />
      </div>

      <!-- Body -->
      <div class="card-item__body">
        <div class="card-item__title">{{ item.camera.nome }}</div>
        <div class="card-item__info">{{ item.camera.descricao }}</div>
        <div class="card-item__info" style="font-size: 0.8rem">
          STATUS: {{ item.camera.status }}
        </div>
        <div class="card-item__meta">
          <span class="meta-source">{{ capitalize(item.camera.praca.sig_praca) }}</span>
          <span class="meta-separator">&bull;</span>
          <span>{{ formatDate(item.data_moderacao) }}</span>
          <span class="meta-separator">&bull;</span>
          <span>{{ formatHour(item.data_moderacao) }}</span>
        </div>
      </div>

      <!-- Actions -->
      <div class="card-item__actions">
        <v-tooltip left color="surface_neutral_selected">
          <template v-slot:activator="{ on, attrs }">
            <div
              class="card-action-box card-action-box--move"
              v-bind="attrs"
              v-on="on"
              @click.prevent="removerCameraExibicao"
             role="button" aria-label="Remover câmera da exibição.">
              <v-icon>mdi-arrow-left</v-icon>
            </div>
          </template>
          <span>Remover câmera da exibição.</span>
        </v-tooltip>

        <ModalEditarInfoCamera :camera-data="item.camera" show-status />

        <ModalPreviewCamera :camera-data="item.camera" />

        <v-tooltip
          left
          color="surface_neutral_selected"
          v-if="item.ordem_exibicao !== camerasEmExibicao.items[0].ordem_exibicao"
        >
          <template v-slot:activator="{ on, attrs }">
            <div
              class="card-action-box"
              v-bind="attrs"
              v-on="on"
              @click.prevent="ordenarCameraModerada('up')"
             role="button" aria-label="Reordenar câmera moderada.">
              <v-icon>mdi-chevron-up</v-icon>
            </div>
          </template>
          <span>Reordenar câmera moderada.</span>
        </v-tooltip>

        <v-tooltip
          left
          color="surface_neutral_selected"
          v-if="
            item.ordem_exibicao !==
            camerasEmExibicao.items[camerasEmExibicao.items.length - 1].ordem_exibicao
          "
        >
          <template v-slot:activator="{ on, attrs }">
            <div
              class="card-action-box"
              v-bind="attrs"
              v-on="on"
              @click.prevent="ordenarCameraModerada('down')"
             role="button" aria-label="Reordenar câmera moderada.">
              <v-icon>mdi-chevron-down</v-icon>
            </div>
          </template>
          <span>Reordenar câmera moderada.</span>
        </v-tooltip>
      </div>
    </div>

    <!-- Tarja actions -->
    <div class="card-tarja-actions">
      <ModalExibirCameraNaTarja
        v-if="!isSelectedToTarja"
        :cod-producao="item.cod_producao"
        :id-camera="item.camera.id"
        :is-disabled="item.camera.status !== 'STREAMING'"
        @change="changeIsSelectedToTarja(item.camera.id, item.cod_producao, true)"
      />
      <ModalRemoverExibicaoCameraTarja
        v-if="isSelectedToTarja"
        :is-disabled="item.camera.status !== 'STREAMING'"
        @change="changeIsSelectedToTarja(item.camera.id, item.cod_producao, false)"
      />
    </div>
  </div>
</template>

<script>
import { apiClient } from "@/services/api";
import { capitalizeString } from "@/utils/capitalizeString";
import { formatDate, formatHour } from "@/utils/dateUtils";
import { mapActions, mapGetters } from "vuex";
import ModalEditarInfoCamera from "../../Modal/Camera/ModalEditarInfoCamera.vue";
import ModalPreviewCamera from "@/components/Modal/Camera/ModalPreviewCamera.vue";
import ModalExibirCameraNaTarja from "@/components/Modal/Camera/ModalExibirCameraNaTarja.vue";
import ModalRemoverExibicaoCameraTarja from "@/components/Modal/Camera/ModalRemoverExibicaoCameraTarja.vue";
import CameraIcon from "@/assets/camera.svg";
export default {
  props: {
    item: Object,
    isSelectedToTarja: Boolean,
  },
  components: {
    ModalEditarInfoCamera,
    ModalPreviewCamera,
    ModalExibirCameraNaTarja,
    ModalRemoverExibicaoCameraTarja,
    CameraIcon,
  },

  data() {
    return {
      isModalImagemAprovadasVisible: false,
      midia_url_aprovadas: "",
      media_type: "",
    };
  },
  computed: {
    ...mapGetters({
      camerasEmExibicao: "cameras/getterCamerasEmExibicao",
    }),
    breakpoint() {
      return this.$vuetify.breakpoint.name;
    },
  },
  methods: {
    ...mapActions({
      getCameras: "cameras/getCameras",
      getCamerasModeradas: "cameras/getCamerasModeradas",
    }),
    formatDate,
    formatHour,
    async changeIsSelectedToTarja(id_camera, cod_producao, is_exibir) {
      try {
        if (is_exibir) {
          await apiClient.patch(`/cameras/exibirNaTarja/${cod_producao}/${id_camera}`);
        } else {
          await apiClient.patch(
            `/cameras/removerExibicaoNaTarja/${cod_producao}/${id_camera}`
          );
        }
        await this.getCamerasModeradas({
          cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
          page: this.currentPage,
          size: 5,
          filtro_texto: this.$store.state.cameras.filtroCamerasModeradas,
          flg_favorita: this.$store.state.cameras.flg_favorita,
        });
        this.$emit("change", id_camera, is_exibir);
      } catch (error) {
        console.error(error);
        const errorMsg = is_exibir
          ? "Não foi possível exibir a câmera na tarja"
          : "Não foi possível remover a câmera da tarja";
        this.$toast.error(errorMsg);
      }
    },
    async showModalImagem(midia_url_aprovadas) {
      this.isModalImagemAprovadasVisible = true;
      this.midia_url_aprovadas = midia_url_aprovadas;
    },
    async closeModalImagem() {
      this.isModalImagemAprovadasVisible = false;
    },
    async removerCameraExibicao() {
      try {
        const id_camera = this.item.camera.id;
        const cod_producao = this.$store.state.producoes.selectedProducao.cod_producao;
        if (this.isSelectedToTarja) {
          localStorage.removeItem("tarjaCameraParams");
          this.$emit("change", this.item.camera.id, false);
        }
        await apiClient.delete(
          `/cameras/removerCameraModerada/${id_camera}/${cod_producao}`
        );
        const { data } = await apiClient.get(`/cameras/checkIfPodExists/${id_camera}`);
        if (data.pod) {
          await apiClient.post(`/cameras/${id_camera}/stop`);
        }
        await this.getCamerasModeradas({
          cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
          page: this.currentPage,
          size: 5,
          filtro_texto: this.$store.state.cameras.filtroCamerasModeradas,
          flg_favorita: this.$store.state.cameras.flg_favorita,
        });
        await this.getCameras({
          cod_praca: this.$store.state.cameras.selectedPraca.cod_praca,
          cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
          filtro_texto: this.$store.state.cameras.filtroCameras,
          flg_favorita: this.$store.state.cameras.flg_favorita,
          page: this.$store.state.cameras.camerasProducao.currentPage,
          size: 5,
        });
      } catch (error) {
        console.error("Erro ao remover câmera da exibição: ", error.message);
        this.$toast.error("Erro ao remover câmera da exibição");
      }
    },
    capitalize(string) {
      return capitalizeString(string);
    },
    startDrag(evt, item) {
      evt.dataTransfer.dropEffect = "move";
      evt.dataTransfer.effectAllowed = "move";
      evt.dataTransfer.setData("text/plain", JSON.stringify(item));
    },
    async ordenarCameraModerada(direction) {
      try {
        const id_camera = this.item.camera.id;
        const cod_producao = this.$store.state.producoes.selectedProducao.cod_producao;
        await apiClient.post(
          `/cameras/ordenarCameraModerada/${id_camera}/${cod_producao}`,
          { up_or_down: direction }
        );
        await this.getCamerasModeradas({
          cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
          page: this.currentPage,
          size: 5,
          filtro_texto: this.$store.state.cameras.filtroCamerasModeradas,
          flg_favorita: this.$store.state.cameras.flg_favorita,
        });
        this.$toast.success("Câmera ordenada com sucesso");
      } catch (error) {
        console.error(error);
        this.$toast.error("Não foi possível ordenar a câmera");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
